module.exports = __webpack_public_path__ + "img/360.a2ca4731.svg";